/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_SubmitInputs */

const en_dispatch_submit = /** @type {(inputs: Dispatch_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispatch`)
};

const fr_dispatch_submit = /** @type {(inputs: Dispatch_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispatcher`)
};

const ms_sg2_dispatch_submit = /** @type {(inputs: Dispatch_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar`)
};

/**
* | output |
* | --- |
* | "Dispatch" |
*
* @param {Dispatch_SubmitInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_submit = /** @type {((inputs?: Dispatch_SubmitInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_SubmitInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_submit(inputs)
	if (locale === "fr") return fr_dispatch_submit(inputs)
	return ms_sg2_dispatch_submit(inputs)
});